import React from 'react';

export default function Experience() {
  const experiences = [
    {
      title: 'MBA Candidate',
      company: 'MIT Sloan School of Management',
      location: 'Cambridge, MA',
      period: '2025 - Present',
      description: [
        'Pursuing Product Management and Entrepreneurship certificates',
        'Member of AI, Technology and Basketball clubs',
      ],
      icon: '🎓',
    },
    {
      title: 'Cloud Deployed Engineer',
      company: 'Amazon Web Services (AWS)',
      location: 'Madrid, Spain',
      period: '2022 - 2025',
      description: [
        'Delivered 6 cloud projects with Fortune 500 companies across Financial, Automotive and Telco sectors',
        'Specialized in DevOps, Infrastructure, MLOps and AI technology domains',
        'Published 4 AWS blog posts and 1 official AWS Architecture',
        '6 AWS certifications (view Credly profile)',
        'Mentored 3 junior consultants and led 10+ consultants in various projects',
        'Worldwide AWS problem solving champion in 2023',
      ],
      icon: '☁️',
    },
    {
      title: 'Business Intelligence Engineer',
      company: 'Amazon',
      location: 'Luxembourg',
      period: '2021 - 2022',
      description: [
        'Collaborated with 5+ teams on Amazon EU\'s middle mile supply chain',
        'Built metrics and visualizations leading to +$1M savings on refunds',
        'Improved customer satisfaction through data-driven decisions',
      ],
      icon: '📊',
    },
    {
      title: 'Student Researcher',
      company: 'Institute of Technological Investigations (IIT)',
      location: 'Madrid, Spain',
      period: '2017 - 2021',
      description: [
        'Developed 4+ high-tech digital solutions including Face Recognition and AI',
        'Worked with Spain\'s biggest industrial companies',
      ],
      icon: '🔬',
    },
  ];

  return (
    <section id="experience" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Experience
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-gray-600 max-w-2xl mx-auto">
            My professional journey combining technology, consulting, and innovation
          </p>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-blue-200"></div>

          <div className="space-y-12">
            {experiences.map((exp, index) => (
              <div
                key={index}
                className={`relative flex flex-col md:flex-row gap-8 ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                {/* Timeline dot */}
                <div className="hidden md:flex absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-blue-600 rounded-full border-4 border-white shadow-lg z-10"></div>

                {/* Content */}
                <div className={`md:w-1/2 ${index % 2 === 0 ? 'md:pr-12 md:text-right' : 'md:pl-12'}`}>
                  <div className="bg-white p-4 sm:p-6 rounded-xl shadow-lg hover:shadow-xl transition">
                    <div className="flex items-start gap-3 sm:gap-4 mb-4">
                      <span className="text-3xl sm:text-4xl">{exp.icon}</span>
                      <div className="flex-1">
                        <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 mb-1">
                          {exp.title}
                        </h3>
                        <div className="text-sm sm:text-base text-blue-600 font-semibold mb-1">
                          {exp.company}
                        </div>
                        <div className="text-xs sm:text-sm text-gray-600">
                          {exp.location} • {exp.period}
                        </div>
                      </div>
                    </div>

                    <ul className="space-y-2 text-sm sm:text-base text-gray-700">
                      {exp.description.map((item, i) => (
                        <li key={i} className="flex items-start gap-2">
                          <svg className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                          </svg>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Spacer for alternating layout */}
                <div className="hidden md:block md:w-1/2"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
